import { orchestrator } from "satcheljs";
import { setTeamDetails } from "sh-team-store";
import setTimeOffReasons from "../actions/setTimeOffReasons";

export default orchestrator( setTeamDetails, async actionMessage => {
    const teamDetails = actionMessage.teamDetails;
    setTimeOffReasons(teamDetails.timeOffReasons);
});